import {ReteachPlate} from '../../constants/actionType';

export const setReteachPlates = (reteachPlates) => ({
  type: ReteachPlate.SET_RETEACH_PLATES,
  reteachPlates,
});

export const setManualReteachCurrentPosition = (currentPosition) => ({
  type: ReteachPlate.SET_MANUAL_RETEACH_CURRENT_POSITION,
  currentPosition,
});

export const setManualReteachCurrentInfo = (currentInfo) => ({
  type: ReteachPlate.SET_MANUAL_RETEACH_CURRENT_INFO,
  currentInfo,
});

export const setManualReteachReturnToCaddy = (returnToCaddy) => ({
  type: ReteachPlate.SET_RETURN_TO_CADDY,
  returnToCaddy,
});

export const setMoveMotionControl = () => ({
  type: ReteachPlate.SET_MOVE_MOTION_CONTROL,
});

export const setSelectedWellStyle = (selectedWellStyle) => ({
  type: ReteachPlate.SET_SELECTED_WELL_STYLE,
  selectedWellStyle,
});

export const setReteachPlateLastViewMode = (lastViewMode) => ({
  type: ReteachPlate.SET_LAST_VIEW_MODE,
  lastViewMode,
});

export const resetReteachPlateState = () => ({
  type: ReteachPlate.RESET_RETEACH_PLATE,
});

export const resetManualReteachPlateState = () => ({
  type: ReteachPlate.RESET_MANUAL_RETEACH_PLATE,
});

export const removeUpdatedPlate = (plateId) => ({
  type: ReteachPlate.REMOVE_UPDATED_PLATE,
  plateId,
});

export const restoreReteachPlateState = (state) => ({type: ReteachPlate.RESTORE_STATE, state});
